export default __webpack_public_path__ + "static/greycliff-cf-regular-8c7b4006e989d177825b2a07396ba5aa.woff2";